import TextSimple, {
  capitalizeName
} from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { IconButton, Tooltip } from "@mui/material";
import {
  IconCloudDownload,
  IconEye,
  IconFileImport,
  IconFiles
} from "@tabler/icons-react";
import download from "downloadjs";
import ViewDocument from "../modals/view-documents/ViewDocument";
import SimpleCard from "../../../../../../shared/components/SimpleCard";
import { useCallback, useMemo } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import useUserIs from "@/src-refactor/modules/shared/hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import MxDetailSmallCard from "@rf-l1/page/details/MxDetailCardSmall";

const DocumentsCard = () => {
  const {
    PROPERTY_DETAIL: { documents, principalData, agents }
  } = useRealEstateDetailContext();

  const { userIs, userLogged } = useUserIs();

  const hidden = useMemo(() => {
    if (
      userLogged.userData?.email == "gracielamarte@remaxm.net" ||
      userIs(ERolesCode.SUPER_ADMIN) ||
      agents.some(x => x.id == userLogged.userData?.people_id)
    ) {
      return false;
    }
    return true;
  }, [documents, principalData, agents]);

  if (hidden) {
    return <></>;
  }

  const enCodeUrl = useCallback((url: string) => {
    const extension = url.split(".").pop();
    return extension;
  }, []);

  const downloadDocument = async (url: string, name: string) => {
    try {
      const newName = `${name}-${principalData.id}.${enCodeUrl(url)}`;
      const response = await axios.get(url, { responseType: "blob" });
      const newBlob = new Blob([response.data], {
        type: response.headers["content-type"]
      });
      download(newBlob, newName);
      toast.success("Documento descargado satisfactoriamente.");
    } catch (error) {
      toast.error("Error al descargar el archivo, intente nuevamente.");
    }
  };

  const onOpenInOtherWindow = (url: string) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  return (
    <MxDetailSmallCard title="Documentos">
      <ContainerButtons>
        {documents.map(document => (
          <DocumentCont>
            <Tooltip title="Descargar documento">
              <Button
                size="small"
                onClick={() => downloadDocument(document.url, document.name)}
              >
                <IconCloudDownload />
              </Button>
            </Tooltip>
            <ViewDocument
              Button={
                <Tooltip title="Ver documento">
                  <Button size="small">
                    <IconEye />
                  </Button>
                </Tooltip>
              }
              url={document.url}
            />
            <Tooltip title="Abrir documento en otra pestaña">
              <Button onClick={() => onOpenInOtherWindow(document.url)} size="small">
                <IconFiles />
              </Button>
            </Tooltip>
            <TextSimple color="blue" size="medium" font="inter" weight="400">
              {capitalizeName(document.name, "first")}
            </TextSimple>
          </DocumentCont>
        ))}
      </ContainerButtons>
    </MxDetailSmallCard>
  );
};

export default DocumentsCard;

const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -15px;
`;

const DocumentCont = styled.div`
  display: grid;
  grid-template-columns: 27px 27px 27px 1fr;
  align-items: center;
  & > span {
    margin-left: 9px;
  }
`;

const Button = styled(IconButton)`
  & svg {
    width: 100%;
    height: 100%;
    /* fill: var(--m-color-blue-03); */
    color: var(--m-color-blue-03);
  }
`;
